import { ResourceByProductType } from 'features/context-ids/types/types';
import { iconByProduct } from 'features/subscriptions/utils';
import { SelectedProductRow } from '../SelectedProductRow';

export const SelectedProductRows = ({
  selectedProducts,
  removeProductHandler,
  handleTenantSelect,
}: {
  selectedProducts: { productCode: string; tenants: ResourceByProductType[] }[];
  removeProductHandler: (index: number) => void;
  handleTenantSelect: (productCode: string, tenantIdWithEnv: string) => void;
}) => (
  <>
    {selectedProducts.map(({ productCode, tenants }, index) => {
      const { name, iconUrl } = iconByProduct[productCode.toLowerCase()] ?? {};
      return (
        <SelectedProductRow
          key={productCode}
          productCode={productCode}
          name={name}
          iconUrl={iconUrl}
          handleTenantSelect={handleTenantSelect}
          removeProductHandler={removeProductHandler}
          tenants={tenants}
          index={index}
        />
      );
    })}
  </>
);
